import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

export type SPSelectionFormLocs =
	| 'SPSelectionFormFieldLabelIntent'
	| 'SPSelectionFormFieldErrorIntentRequired'
	| 'SPSelectionFormFieldErrorIntentInvalid'
	| 'SPSelectionFormFieldLabelCredential'
	| 'SPSelectionFormFieldErrorNoCredentials'
	| 'SPSelectionFormFieldErrorCredentialRequired'
	| 'SPSelectionFormFieldErrorCredentialInvalid'
	| 'SPSelectionFormFieldLabelItemGroup'
	| 'SPSelectionFormFieldErrorItemGroupRequired'
	| 'SPSelectionFormFieldErrorItemGroupInvalid'
	| 'SPSelectionFormFieldLabelItemName'
	| 'SPSelectionFormFieldErrorItemNameRequired'
	| 'SPSelectionFormFieldErrorItemNameInvalid'
	| 'SPSelectionFormButtonStepOneNext'
	| 'SPSelectionFormNoticeNoCredentials'
	| 'SPSelectionFormFieldLabelOverrideGroup'
	| 'SPSelectionFormFieldErrorOverrideGroupRequired'
	| 'SPSelectionFormFieldErrorOverrideGroupInvalid'
	| 'SPSelectionFormFieldLabelOverrideName'
	| 'SPSelectionFormFieldErrorOverrideNameRequired'
	| 'SPSelectionFormFieldErrorOverrideNameInvalid';

export type CPSelectionFormLocs =
	| 'CPSelectionFormFieldLabelIntent'
	| 'CPSelectionFormFieldErrorIntentRequired'
	| 'CPSelectionFormFieldErrorIntentInvalid'
	| 'CPSelectionFormFieldLabelCredential'
	| 'CPSelectionFormFieldErrorNoCredentials'
	| 'CPSelectionFormFieldErrorCredentialRequired'
	| 'CPSelectionFormFieldErrorCredentialInvalid'
	| 'CPSelectionFormFieldLabelItemGroup'
	| 'CPSelectionFormFieldErrorItemGroupRequired'
	| 'CPSelectionFormFieldErrorItemGroupInvalid'
	| 'CPSelectionFormFieldLabelItemName'
	| 'CPSelectionFormFieldErrorItemNameRequired'
	| 'CPSelectionFormFieldErrorItemNameInvalid'
	| 'CPSelectionFormButtonStepOneNext'
	| 'CPSelectionFormNoticeNoCredentials'
	| 'CPSelectionFormFieldLabelOverrideGroup'
	| 'CPSelectionFormFieldErrorOverrideGroupRequired'
	| 'CPSelectionFormFieldErrorOverrideGroupInvalid'
	| 'CPSelectionFormFieldLabelOverrideName'
	| 'CPSelectionFormFieldErrorOverrideNameRequired'
	| 'CPSelectionFormFieldErrorOverrideNameInvalid';

export const spSelectionFormLocs: LocDefs<SPSelectionFormLocs> = {
	SPSelectionFormFieldLabelIntent: {
		defaultValue: 'Intent',
		description: 'Label for the intent field',
		displayPath: 'History|Selection Form|Intent',
		displayType: 'Label',
		feature: HubFeature.OtherRequirementUpload,
		portal: 'SP',
		legacyName:
			'OtherRequirement.Upload/Candidates.ProgramHistory.UploadItems.FieldLabel.Intent',
	},
	SPSelectionFormFieldErrorIntentRequired: {
		defaultValue: 'This field is required',
		description: 'Error message when intent is required',
		displayPath: 'History|Selection Form|Intent Required',
		displayType: 'Error',
		feature: HubFeature.OtherRequirementUpload,
		portal: 'SP',
		legacyName:
			'OtherRequirement.Upload/Candidates.ProgramHistory.UploadItems.FieldError.IntentRequired',
	},
	SPSelectionFormFieldErrorIntentInvalid: {
		defaultValue: 'You must choose an option from the list',
		description: 'Error message when intent is invalid',
		displayPath: 'History|Selection Form|Intent Invalid',
		displayType: 'Error',
		feature: HubFeature.OtherRequirementUpload,
		portal: 'SP',
		legacyName:
			'OtherRequirement.Upload/Candidates.ProgramHistory.UploadItems.FieldError.IntentInvalid',
	},
	SPSelectionFormFieldLabelCredential: {
		defaultValue: 'Credentials',
		description: 'Label for the credential field',
		displayPath: 'History|Selection Form|Credential',
		displayType: 'Label',
		feature: HubFeature.OtherRequirementUpload,
		portal: 'SP',
		legacyName:
			'OtherRequirement.Upload/Candidates.ProgramHistory.UploadItems.FieldLabel.Credential',
	},
	SPSelectionFormFieldErrorNoCredentials: {
		defaultValue:
			'No credentials matching the criteria were found. Please select a different intent.',
		description: 'Error message when no credentials are found',
		displayPath: 'History|Selection Form|No Credentials',
		displayType: 'Error',
		feature: HubFeature.OtherRequirementUpload,
		portal: 'SP',
		legacyName:
			'OtherRequirement.Upload/Candidates.ProgramHistory.UploadItems.FieldError.NoCredentials',
	},
	SPSelectionFormFieldErrorCredentialRequired: {
		defaultValue: 'This field is required',
		description: 'Error message when credential is required',
		displayPath: 'History|Selection Form|Credential Required',
		displayType: 'Error',
		feature: HubFeature.OtherRequirementUpload,
		portal: 'SP',
		legacyName:
			'OtherRequirement.Upload/Candidates.ProgramHistory.UploadItems.FieldError.CredentialRequired',
	},
	SPSelectionFormFieldErrorCredentialInvalid: {
		defaultValue: 'You must choose an option from the list',
		description: 'Error message when credential is invalid',
		displayPath: 'History|Selection Form|Credential Invalid',
		displayType: 'Error',
		feature: HubFeature.OtherRequirementUpload,
		portal: 'SP',
		legacyName:
			'OtherRequirement.Upload/Candidates.ProgramHistory.UploadItems.FieldError.CredentialInvalid',
	},
	SPSelectionFormFieldLabelItemGroup: {
		defaultValue: 'Item Group',
		description: 'Label for the item group field',
		displayPath: 'History|Selection Form|Item Group',
		displayType: 'Label',
		feature: HubFeature.OtherRequirementUpload,
		portal: 'SP',
		legacyName:
			'OtherRequirement.Upload/Candidates.ProgramHistory.UploadItems.FieldLabel.ItemGroup',
	},
	SPSelectionFormFieldErrorItemGroupRequired: {
		defaultValue: 'This field is required',
		description: 'Error message when item group is required',
		displayPath: 'History|Selection Form|Item Group Required',
		displayType: 'Error',
		feature: HubFeature.OtherRequirementUpload,
		portal: 'SP',
		legacyName:
			'OtherRequirement.Upload/Candidates.ProgramHistory.UploadItems.FieldError.ItemGroupRequired',
	},
	SPSelectionFormFieldErrorItemGroupInvalid: {
		defaultValue: 'You must choose an option from the list',
		description: 'Error message when item group is invalid',
		displayPath: 'History|Selection Form|Item Group Invalid',
		displayType: 'Error',
		feature: HubFeature.OtherRequirementUpload,
		portal: 'SP',
		legacyName:
			'OtherRequirement.Upload/Candidates.ProgramHistory.UploadItems.FieldError.ItemGroupInvalid',
	},
	SPSelectionFormFieldLabelItemName: {
		defaultValue: 'Item Name',
		description: 'Label for the item name field',
		displayPath: 'History|Selection Form|Item Name',
		displayType: 'Label',
		feature: HubFeature.OtherRequirementUpload,
		portal: 'SP',
		legacyName:
			'OtherRequirement.Upload/Candidates.ProgramHistory.UploadItems.FieldLabel.ItemName',
	},
	SPSelectionFormFieldErrorItemNameRequired: {
		defaultValue: 'This field is required',
		description: 'Error message when item name is required',
		displayPath: 'History|Selection Form|Item Name Required',
		displayType: 'Error',
		feature: HubFeature.OtherRequirementUpload,
		portal: 'SP',
		legacyName:
			'OtherRequirement.Upload/Candidates.ProgramHistory.UploadItems.FieldError.ItemNameRequired',
	},
	SPSelectionFormFieldErrorItemNameInvalid: {
		defaultValue: 'You must choose an option from the list',
		description: 'Error message when item name is invalid',
		displayPath: 'History|Selection Form|Item Name Invalid',
		displayType: 'Error',
		feature: HubFeature.OtherRequirementUpload,
		portal: 'SP',
		legacyName:
			'OtherRequirement.Upload/Candidates.ProgramHistory.UploadItems.FieldError.ItemNameInvalid',
	},
	SPSelectionFormButtonStepOneNext: {
		defaultValue: 'Next',
		description: 'Text for the next button',
		displayPath: 'History|Selection Form|Next Button',
		displayType: 'Button',
		feature: HubFeature.OtherRequirementUpload,
		portal: 'SP',
		legacyName:
			'OtherRequirement.Upload/Candidates.ProgramHistory.UploadItems.Button.StepOneNext',
	},
	SPSelectionFormNoticeNoCredentials: {
		defaultValue:
			'No credentials matching the criteria were found. Please select a different intent.',
		description: 'Notification message when no credentials matching the criteria are found',
		displayPath: 'History|Selection Form|No Credentials',
		displayType: 'Notification',
		feature: HubFeature.OtherRequirementUpload,
		portal: 'SP',
	},
	SPSelectionFormFieldLabelOverrideGroup: {
		defaultValue: 'Group',
		description: 'Label for the override group field',
		displayPath: 'History|Selection Form|Override Group',
		displayType: 'Label',
		feature: HubFeature.OtherRequirementAdvancedSelection,
		portal: 'SP',
		htmlAllowed: false,
		shared: false,
	},
	SPSelectionFormFieldErrorOverrideGroupRequired: {
		defaultValue: 'This field is required',
		description: 'Error message when override group is required',
		displayPath: 'History|Selection Form|Override Group Required',
		displayType: 'Error',
		feature: HubFeature.OtherRequirementAdvancedSelection,
		portal: 'SP',
		htmlAllowed: false,
		shared: false,
	},
	SPSelectionFormFieldErrorOverrideGroupInvalid: {
		defaultValue: 'You must choose an option from the list',
		description: 'Error message when override group is invalid',
		displayPath: 'History|Selection Form|Override Group Invalid',
		displayType: 'Error',
		feature: HubFeature.OtherRequirementAdvancedSelection,
		portal: 'SP',
		htmlAllowed: false,
		shared: false,
	},
	SPSelectionFormFieldLabelOverrideName: {
		defaultValue: 'Name',
		description: 'Label for the override name field',
		displayPath: 'History|Selection Form|Override Name',
		displayType: 'Label',
		feature: HubFeature.OtherRequirementAdvancedSelection,
		portal: 'SP',
		htmlAllowed: false,
		shared: false,
	},
	SPSelectionFormFieldErrorOverrideNameRequired: {
		defaultValue: 'This field is required',
		description: 'Error message when override name is required',
		displayPath: 'History|Selection Form|Override Name Required',
		displayType: 'Error',
		feature: HubFeature.OtherRequirementAdvancedSelection,
		portal: 'SP',
		htmlAllowed: false,
		shared: false,
	},
	SPSelectionFormFieldErrorOverrideNameInvalid: {
		defaultValue: 'You must choose an option from the list',
		description: 'Error message when override name is invalid',
		displayPath: 'History|Selection Form|Override Name Invalid',
		displayType: 'Error',
		feature: HubFeature.OtherRequirementAdvancedSelection,
		portal: 'SP',
		htmlAllowed: false,
		shared: false,
	},
};

export const cpSelectionFormLocs: LocDefs<CPSelectionFormLocs> = {
	CPSelectionFormFieldLabelIntent: {
		defaultValue: 'Intent',
		description: 'Label for the intent field',
		displayPath: 'Candidate|Program History|Selection Form|Intent',
		displayType: 'Label',
		feature: HubFeature.OtherRequirementUpload,
		portal: 'CP',
		legacyName: 'OtherRequirement.Upload.CandidateAccess/History.UploadItems.FieldLabel.Intent',
	},
	CPSelectionFormFieldErrorIntentRequired: {
		defaultValue: 'This field is required',
		description: 'Error message when intent is required',
		displayPath: 'Candidate|Program History|Selection Form|Intent Required',
		displayType: 'Error',
		feature: HubFeature.OtherRequirementUploadCandidateAccess,
		portal: 'CP',
		legacyName:
			'OtherRequirement.Upload.CandidateAccess/History.UploadItems.FieldError.IntentRequired',
	},
	CPSelectionFormFieldErrorIntentInvalid: {
		defaultValue: 'You must choose an option from the list',
		description: 'Error message when intent is invalid',
		displayPath: 'Candidate|Program History|Selection Form|Intent Invalid',
		displayType: 'Error',
		feature: HubFeature.OtherRequirementUploadCandidateAccess,
		portal: 'CP',
		legacyName:
			'OtherRequirement.Upload.CandidateAccess/History.UploadItems.FieldError.IntentInvalid',
	},
	CPSelectionFormFieldLabelCredential: {
		defaultValue: 'Credentials',
		description: 'Label for the credential field',
		displayPath: 'Candidate|Program History|Selection Form|Credential',
		displayType: 'Label',
		feature: HubFeature.OtherRequirementUploadCandidateAccess,
		portal: 'CP',
		legacyName:
			'OtherRequirement.Upload.CandidateAccess/History.UploadItems.FieldLabel.Credential',
	},
	CPSelectionFormFieldErrorNoCredentials: {
		defaultValue:
			'No credentials matching the criteria were found. Please select a different intent.',
		description: 'Error message when no credentials are found',
		displayPath: 'Candidate|Program History|Selection Form|No Credentials',
		displayType: 'Error',
		feature: HubFeature.OtherRequirementUploadCandidateAccess,
		portal: 'CP',
		legacyName:
			'OtherRequirement.Upload.CandidateAccess/History.UploadItems.FieldError.NoCredentials',
	},
	CPSelectionFormFieldErrorCredentialRequired: {
		defaultValue: 'This field is required',
		description: 'Error message when credential is required',
		displayPath: 'Candidate|Program History|Selection Form|Credential Required',
		displayType: 'Error',
		feature: HubFeature.OtherRequirementUploadCandidateAccess,
		portal: 'CP',
		legacyName:
			'OtherRequirement.Upload.CandidateAccess/History.UploadItems.FieldError.CredentialRequired',
	},
	CPSelectionFormFieldErrorCredentialInvalid: {
		defaultValue: 'You must choose an option from the list',
		description: 'Error message when credential is invalid',
		displayPath: 'Candidate|Program History|Selection Form|Credential Invalid',
		displayType: 'Error',
		feature: HubFeature.OtherRequirementUploadCandidateAccess,
		portal: 'CP',
		legacyName:
			'OtherRequirement.Upload.CandidateAccess/History.UploadItems.FieldError.CredentialInvalid',
	},
	CPSelectionFormFieldLabelItemGroup: {
		defaultValue: 'Item Group',
		description: 'Label for the item group field',
		displayPath: 'Candidate|Program History|Selection Form|Item Group',
		displayType: 'Label',
		feature: HubFeature.OtherRequirementUploadCandidateAccess,
		portal: 'CP',
		legacyName:
			'OtherRequirement.Upload.CandidateAccess/History.UploadItems.FieldLabel.ItemGroup',
	},
	CPSelectionFormFieldErrorItemGroupRequired: {
		defaultValue: 'This field is required',
		description: 'Error message when item group is required',
		displayPath: 'Candidate|Program History|Selection Form|Item Group Required',
		displayType: 'Error',
		feature: HubFeature.OtherRequirementUploadCandidateAccess,
		portal: 'CP',
		legacyName:
			'OtherRequirement.Upload.CandidateAccess/History.UploadItems.FieldError.ItemGroupRequired',
	},
	CPSelectionFormFieldErrorItemGroupInvalid: {
		defaultValue: 'You must choose an option from the list',
		description: 'Error message when item group is invalid',
		displayPath: 'Candidate|Program History|Selection Form|Item Group Invalid',
		displayType: 'Error',
		feature: HubFeature.OtherRequirementUploadCandidateAccess,
		portal: 'CP',
		legacyName:
			'OtherRequirement.Upload.CandidateAccess/History.UploadItems.FieldError.ItemGroupInvalid',
	},
	CPSelectionFormFieldLabelItemName: {
		defaultValue: 'Item Name',
		description: 'Label for the item name field',
		displayPath: 'Candidate|Program History|Selection Form|Item Name',
		displayType: 'Label',
		feature: HubFeature.OtherRequirementUploadCandidateAccess,
		portal: 'CP',
		legacyName:
			'OtherRequirement.Upload.CandidateAccess/History.UploadItems.FieldLabel.ItemName',
	},
	CPSelectionFormFieldErrorItemNameRequired: {
		defaultValue: 'This field is required',
		description: 'Error message when item name is required',
		displayPath: 'Candidate|Program History|Selection Form|Item Name Required',
		displayType: 'Error',
		feature: HubFeature.OtherRequirementUploadCandidateAccess,
		portal: 'CP',
		legacyName:
			'OtherRequirement.Upload.CandidateAccess/History.UploadItems.FieldError.ItemNameRequired',
	},
	CPSelectionFormFieldErrorItemNameInvalid: {
		defaultValue: 'You must choose an option from the list',
		description: 'Error message when item name is invalid',
		displayPath: 'Candidate|Program History|Selection Form|Item Name Invalid',
		displayType: 'Error',
		feature: HubFeature.OtherRequirementUploadCandidateAccess,
		portal: 'CP',
		legacyName:
			'OtherRequirement.Upload.CandidateAccess/History.UploadItems.FieldError.ItemNameInvalid',
	},
	CPSelectionFormButtonStepOneNext: {
		defaultValue: 'Next',
		description: 'Text for the next button',
		displayPath: 'Candidate|Program History|Selection Form|Next Button',
		displayType: 'Button',
		feature: HubFeature.OtherRequirementUploadCandidateAccess,
		portal: 'CP',
		legacyName:
			'OtherRequirement.Upload.CandidateAccess/History.UploadItems.Button.StepOneNext',
	},
	CPSelectionFormNoticeNoCredentials: {
		defaultValue:
			'No credentials matching the criteria were found. Please select a different intent.',
		description: 'Notification message when no credentials matching the criteria are found',
		displayPath: 'Candidate|Program History|Selection Form|No Credentials',
		displayType: 'Notification',
		feature: HubFeature.OtherRequirementUploadCandidateAccess,
		portal: 'CP',
		legacyName: 'OtherRequirement.Upload.CandidateAccess/History.UploadItems.NoCredentials',
	},
	CPSelectionFormFieldLabelOverrideGroup: {
		defaultValue: 'Group',
		description: 'Label for the override group field',
		displayPath: 'Candidate|Program History|Selection Form|Override Group',
		displayType: 'Label',
		feature: HubFeature.OtherRequirementAdvancedSelection,
		portal: 'CP',
		htmlAllowed: false,
		shared: false,
	},
	CPSelectionFormFieldErrorOverrideGroupRequired: {
		defaultValue: 'This field is required',
		description: 'Error message when override group is required',
		displayPath: 'Candidate|Program History|Selection Form|Override Group Required',
		displayType: 'Error',
		feature: HubFeature.OtherRequirementAdvancedSelection,
		portal: 'CP',
		htmlAllowed: false,
		shared: false,
	},
	CPSelectionFormFieldErrorOverrideGroupInvalid: {
		defaultValue: 'You must choose an option from the list',
		description: 'Error message when override group is invalid',
		displayPath: 'Candidate|Program History|Selection Form|Override Group Invalid',
		displayType: 'Error',
		feature: HubFeature.OtherRequirementAdvancedSelection,
		portal: 'CP',
		htmlAllowed: false,
		shared: false,
	},
	CPSelectionFormFieldLabelOverrideName: {
		defaultValue: 'Name',
		description: 'Label for the override name field',
		displayPath: 'Candidate|Program History|Selection Form|Override Name',
		displayType: 'Label',
		feature: HubFeature.OtherRequirementAdvancedSelection,
		portal: 'CP',
		htmlAllowed: false,
		shared: false,
	},
	CPSelectionFormFieldErrorOverrideNameRequired: {
		defaultValue: 'This field is required',
		description: 'Error message when override name is required',
		displayPath: 'Candidate|Program History|Selection Form|Override Name Required',
		displayType: 'Error',
		feature: HubFeature.OtherRequirementAdvancedSelection,
		portal: 'CP',
		htmlAllowed: false,
		shared: false,
	},
	CPSelectionFormFieldErrorOverrideNameInvalid: {
		defaultValue: 'You must choose an option from the list',
		description: 'Error message when override name is invalid',
		displayPath: 'Candidate|Program History|Selection Form|Override Name Invalid',
		displayType: 'Error',
		feature: HubFeature.OtherRequirementAdvancedSelection,
		portal: 'CP',
		htmlAllowed: false,
		shared: false,
	},
};

export type SPSelectionFormLocKeys = LocMap<SPSelectionFormLocs>;
export const spSelectionFormLocKeys: SPSelectionFormLocKeys =
	MapLocKeys<SPSelectionFormLocs>(spSelectionFormLocs);

export type CPSelectionFormLocKeys = LocMap<CPSelectionFormLocs>;
export const cpSelectionFormLocKeys: CPSelectionFormLocKeys =
	MapLocKeys<CPSelectionFormLocs>(cpSelectionFormLocs);
